import type { SVGProps } from 'react'

export function AldapaMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 44 44" role="img" aria-label="Aldapa Systems" {...props}>
      <rect x=".5" y=".5" width="43" height="43" rx="2.5" fill="none" stroke="currentColor" strokeOpacity=".45" />
      <path fill="currentColor" d="M12 34 20.2 10h4L32 34h-4.6l-1.8-5.8h-7.2L16.6 34H12Zm7.6-9.6h4.9L22.1 16l-2.5 8.4Z" />
    </svg>
  )
}
